export const actionNames={  
    // MENU SELECTED ITEMS
    SET_MENU_ITEM_GROUP:"SET_MENU_ITEM_GROUP",
    SET_MENU_ITEM:"SET_MENU_ITEM",
    SET_MENU_ITEM_TITLE:"SET_MENU_ITEM_TITLE",

    //security
    SET_CURRENT_USER:"SET_CURRENT_USER",
    SET_MENU:"SET_MENU",
    LOGOUT:"LOGOUT",
    REGISTER:"REGISTER",
    
    SOLICITUD_EMPADRONAMIENTO_SET_STEP: "SOLICITUD_EMPADRONAMIENTO_SET_STEP",
    SOLICITUD_EMPADRONAMIENTO_SET_STEP_PROCESO_REGISTRO_DE_CONTACTO: "SOLICITUD_EMPADRONAMIENTO_SET_STEP_PROCESO_REGISTRO_DE_CONTACTO",
    SOLICITUD_EMPADRONAMIENTO_SET_LUGAR_RESIDENCIA: "SOLICITUD_EMPADRONAMIENTO_SET_LUGAR_RESIDENCIA",
    SOLICITUD_EMPADRONAMIENTO_SET_INCONSISTENCIAS_RENAP: "SOLICITUD_EMPADRONAMIENTO_SET_INCONSISTENCIAS_RENAP",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA",
    SOLICITUD_EMPADRONAMIENTO_SET_ARRAY_LISTADO: "SOLICITUD_EMPADRONAMIENTO_SET_ARRAY_LISTADO",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD",
    SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO: "SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO",
    SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD: "SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD",
    SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PROCESO_REGISTRO_DE_CONTACTO: "SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PROCESO_REGISTRO_DE_CONTACTO",
    SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI: "SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI",
    SOLICITUD_EMPADRONAMIENTO_SET_ESTA_EMPADRONADO: "SOLICITUD_EMPADRONAMIENTO_SET_ESTA_EMPADRONADO",
    SOLICITUD_EMPADRONAMIENTO_SET_ESTA_FALLECIDO: "SOLICITUD_EMPADRONAMIENTO_SET_ESTA_FALLECIDO",
    SOLICITUD_EMPADRONAMIENTO_SET_EVENTO_RENAP: "SOLICITUD_EMPADRONAMIENTO_SET_EVENTO_RENAP",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_EMPADRONADOR: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_EMPADRONADOR",
    SOLICITUD_EMPADRONAMIENTO_SET_HOMONIMOS: "SOLICITUD_EMPADRONAMIENTO_SET_HOMONIMOS",
    DATOS_GENERALES_CIUDADANO: "DATOS_GENERALES_CIUDADANO",
    DATOS_SOLICITUD_EXTRANJERO: "DATOS_SOLICITUD_EXTRANJERO",
    SOLICITUD_EMPADRONAMIENTO_SET_LISTADOS_ARRAY: "SOLICITUD_EMPADRONAMIENTO_SET_LISTADOS_ARRAY",
    SOLICITUD_EMPADRONAMIENTO_SET_LIMITE_REGISTRO_DE_CONTACTO: "SOLICITUD_EMPADRONAMIENTO_SET_LIMITE_REGISTRO_DE_CONTACTO",
    SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_TSE_VIRTUAL_ENVIADA: "SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_TSE_VIRTUAL_ENVIADA",
    SOLICITUD_EMPADRONAMIENTO_SET_TAB_VALUE_INITIAL: "SOLICITUD_EMPADRONAMIENTO_SET_TAB_VALUE_INITIAL",
    SOLICITUD_EMPADRONAMIENTO_SET_RESIDENCIA_ELECTORAL_ACTUAL: "SOLICITUD_EMPADRONAMIENTO_SET_RESIDENCIA_ELECTORAL_ACTUAL",
    RANGO_NO_BOLETAS: "RANGO_NO_BOLETAS",
    
    //sign up stepper
    SIGNUP_SET_DATA : "SIGNUP_SET_DATA",
    SIGNUP_SET_FILES: "SIGNUP_SET_FILES",
    SIGNUP_SET_FILE_BY_INDEX:  "SIGNUP_SET_FILE_BY_INDEX",
    SIGNUP_SET_STEP:  "SIGNUP_SET_STEP",
    SIGNUP_SET_TOKEN_RECAPCHA:"SIGNUP_SET_TOKEN_RECAPCHA",
    SIGNUP_SET_RECAPTCHA_STATUS:"SIGNUP_SET_RECAPTCHA_STATUS",
    SIGNUP_SET_ARCHIVO_SOLICITUD_GRANDE:"SIGNUP_SET_ARCHIVO_SOLICITUD_GRANDE",
    SIGNUP_SET_ARCHIVO_DPI_FRONTAL_GRANDE:"SIGNUP_SET_ARCHIVO_DPI_FRONTAL_GRANDE",
    SIGNUP_SET_ARCHIVO_DPI_TRASERA_GRANDE:"SIGNUP_SET_ARCHIVO_DPI_TRASERA_GRANDE",
    SIGNUP_SET_ARCHIVO_FOTO_DPI_GRANDE:"SIGNUP_SET_ARCHIVO_FOTO_DPI_GRANDE",
    SIGNUP_SET_TIPO_ARCHIVO_SOLICITUD_DIFERENTE:"SIGNUP_SET_TIPO_ARCHIVO_SOLICITUD_DIFERENTE",
    SIGNUP_SET_TIPO_ARCHIVO_DPI_FRONTAL_DIFERENTE:"SIGNUP_SET_TIPO_ARCHIVO_DPI_FRONTAL_DIFERENTE",
    SIGNUP_SET_TIPO_ARCHIVO_DPI_TRASERA_DIFERENTE:"SIGNUP_SET_TIPO_ARCHIVO_DPI_TRASERA_DIFERENTE",
    SIGNUP_SET_TIPO_ARCHIVO_FOTO_DPI_DIFERENTE:"SIGNUP_SET_TIPO_ARCHIVO_FOTO_DPI_DIFERENTE",
    SIGNUP_SET_NOMBRE_TITULO_ARCHIVO: "SIGNUP_SET_NOMBRE_TITULO_ARCHIVO",

     //CitasDeEmpadronamiento
    CITA_EMPADRONAMIENTO_SET_STEP: "CITA_EMPADRONAMIENTO_SET_STEP",
    CITA_EMPADRONAMIENTO_SET_LUGAR_RESIDENCIA: "CITA_EMPADRONAMIENTO_SET_LUGAR_RESIDENCIA",
    CITA_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE: "CITA_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE",
    CITA_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA: "CITA_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA",
    CITA_EMPADRONAMIENTO_SET_ARRAY_LISTADO: "CITA_EMPADRONAMIENTO_SET_ARRAY_LISTADO",
    CITA_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP: "CITA_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_RENAP",
    CITA_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD: "CITA_EMPADRONAMIENTO_SET_DATOS_IDENTIDAD",
    CITA_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO: "CITA_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO",
    CITA_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD: "CITA_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD",
    CITA_EMPADRONAMIENTO_SET_CUI_DPI: "CITA_EMPADRONAMIENTO_SET_CUI_DPI",
    CITA_EMPADRONAMIENTO_SET_ESTA_EMPADRONADO: "CITA_EMPADRONAMIENTO_SET_ESTA_EMPADRONADO",
    CITA_EMPADRONAMIENTO_SET_ESTA_FALLECIDO: "CITA_EMPADRONAMIENTO_SET_ESTA_FALLECIDO",
    CITA_EMPADRONAMIENTO_SET_EVENTO_RENAP: "CITA_EMPADRONAMIENTO_SET_EVENTO_RENAP",
    CITA_EMPADRONAMIENTO_SET_DATOS_EMPADRONADOR: "CITA_EMPADRONAMIENTO_SET_DATOS_EMPADRONADOR",
    CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO: "CITA_EMPADRONAMIENTO_SET_CITA_EN_PROCESO",
 
    // empadronamiento del extranjero
    SET_DATA_DATOS_IDENTIDAD : "SET_DATA_DATOS_IDENTIDAD",
    CLEAR_DATA_DATOS_IDENTIDAD : "CLEAR_DATA_DATOS_IDENTIDAD",
    SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP: "SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP",
    STEP_RECHAZO_SOLICITUD_EXTRANJERO_SET_STEP: "STEP_RECHAZO_SOLICITUD_EXTRANJERO_SET_STEP",
    SET_DATA_IS_REGISTERED: "SET_DATA_IS_REGISTERED",
    CLEAR_DATA_IS_REGISTERED: "CLEAR_DATA_IS_REGISTERED",
    SET_DATOS_GENERALES_DEL_CIUDADANO: "SET_DATOS_GENERALES_DEL_CIUDADANO",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA_DEL_CIUDADANO: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA_DEL_CIUDADANO",
    SET_DATA_HOMONIMO_CIUDADANO: "SET_DATA_HOMONIMO_CIUDADANO",
    SET_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO: "SET_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO",
    CLEAR_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO: "CLEAR_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO",
    SET_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO_NO_EMPADRONADO: "SET_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO_NO_EMPADRONADO",
    SET_DATA_VALIDAR_IDENTIDAD_FOTO_HUELLA_FIRMA: "SET_DATA_VALIDAR_IDENTIDAD_FOTO_HUELLA_FIRMA",
    SET_DATA_ENTERED_BY_THE_USER: "SET_DATA_ENTERED_BY_THE_USER",
    CLEAR_DATOS_GENERALES_DEL_CIUDADANO: "CLEAR_DATOS_GENERALES_DEL_CIUDADANO",
    SET_PROFILE_IMG: "SET_PROFILE_IMG",
    CLEAR_PROFILE_IMG: "CLEAR_PROFILE_IMG",
    SET_DATA_IDENTIDAD_FOTOS_VACIA: "SET_DATA_IDENTIDAD_FOTOS_VACIA",
    SOLICITUD_EMPADRONAMIENTO_SET_ES_PADRON_RENAP: "SOLICITUD_EMPADRONAMIENTO_SET_ES_PADRON_RENAP",
    SET_CITIZEN_IDENTITY_DATA: "SET_CITIZEN_IDENTITY_DATA",
    CLEAR_CITIZEN_IDENTITY_DATA: "CLEAR_CITIZEN_IDENTITY_DATA",
    SET_CUI_CITIZEN: "SET_CUI_CITIZEN",
    SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO: "SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_SOLICITUD_GENERADO",
    SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION: "SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_MUNICIPIOS",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_COMUNIDAD: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_COMUNIDAD",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_PAISES: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_PAISES",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_ESTADO_DEL_PAIS: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_ESTADO_DEL_PAIS",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_CIUDAD_DEL_ESTADO_DEL_PAIS: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_CIUDAD_DEL_ESTADO_DEL_PAIS",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_OCUPACIONES: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_OCUPACIONES",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_VECINDAD: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_VECINDAD",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_NACIMIENTO: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_NACIMIENTO",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_RESIDENCIA: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DEPARTAMENTO_RESIDENCIA",

    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_CIUDADANO: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_CIUDADANO",
    SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_INTERNO: "SOLICITUD_EMPADRONAMIENTO_SET_CATALOGOS_DE_RECHAZO_DE_INTERNO",
    SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO: "SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO",
    SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO: "SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO",
    SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_EN_EL_EXTRANJERO: "SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_EN_EL_EXTRANJERO",
    ID_SOLICITUD_DELEGACION_PROCESADO: "ID_SOLICITUD_DELEGACION_PROCESADO",
    DATOS_SOLICITUD_DELEGACION: "DATOS_SOLICITUD_DELEGACION",
    GET_NUMERO_BOLETA_RENAP: "GET_NUMERO_BOLETA_RENAP",

    //empadronamiento portal web
    SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB: "SOLICITUD_EMPADRONAMIENTO_SET_STEP_PORTAL_WEB",
    SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PORTAL_WEB: "SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PORTAL_WEB",
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB: "SOLICITUD_EMPADRONAMIENTO_SET_DATOS_PORTAL_WEB",
    SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB: "SOLICITUD_EMPADRONAMIENTO_SET_CUI_DPI_PORTAL_WEB",
    SET_RESIDENCIA_ACTUAL_PADRON: "SET_RESIDENCIA_ACTUAL_PADRON",
    

    // modulo de fallecidos
    MODULO_FALLECIDOS_SET_STEPPER:"MODULO_FALLECIDOS_SET_STEPPER",
    MODULO_FALLECIDOS_SET_REGISTRO_HOMONIMOS_SELECCIONADO:"MODULO_FALLECIDOS_SET_REGISTRO_HOMONIMOS_SELECCIONADO",
    MODULO_FALLECIDOS_SET_TAB:"MODULO_FALLECIDOS_SET_TAB",
    MODULO_FALLECIDOS_SET_MENU:"MODULO_FALLECIDOS_SET_MENU",
    MODULO_FALLECIDOS_SET_PRIMER_RENDER:"MODULO_FALLECIDOS_SET_PRIMER_RENDER",
    MODULO_FALLECIDOS_SET_CATALOGO_DEPARTAMENTOS:"MODULO_FALLECIDOS_SET_CATALOGO_DEPARTAMENTOS",
    MODULO_FALLECIDOS_SET_CATALOGO_MUNICIPIOS:"MODULO_FALLECIDOS_SET_CATALOGO_MUNICIPIOS",
    MODULO_FALLECIDOS_SET_CATALOGO_AUXILIATURAS_DE_MUNICIPIOS:"MODULO_FALLECIDOS_SET_CATALOGO_AUXILIATURAS_DE_MUNICIPIOS",
    
    //modulo para cambio de puestos de empadronamiento
    CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_PUESTOS:"CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_PUESTOS",
    CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_USUARIOS_DS:"CAMBIO_PUESTO_EMPADRONAMIENTO_CATALOGO_USUARIOS_DS",

    //discapacidad
    CATALOGO_DISCAPACIDAD:"CATALOGO_DISCAPACIDAD",
    CATALOGO_CLASIFICACION_DISCAPACIDAD:"CATALOGO_CLASIFICACION_DISCAPACIDAD",

    //dialogo
    SET_DIALOGO_STATUS:"SET_DIALOGO_STATUS",
    
};